import { FC } from 'react';
import styled from 'styled-components';
import { IconKey, iconsSvgPath } from './svgIconsParams';
import { theme } from '../theme';

const SvgItem = styled.div<{ color: string; size: string }>`
  width: ${({ size }) => (size ? `${size}px` : 'auto')};
  height: ${({ size }) => (size ? `${size}px` : 'auto')};
  path {
    fill: ${({ theme, color }) => (color ? color : theme.vars.newColor.darkGS3)};
  }
`;

export type IconSize = '8' | '16' | '24' | '32' | '40';

export interface IconsProps extends IntrinsicProps {
  id?: string;
  name: IconKey;
  color?: string;
  size?: IconSize;
}

export const SvgIcon: FC<IconsProps> = ({
  id,
  color = theme.vars.newColor.darkGS2,
  name,
  size = '16',
  ...props
}: IconsProps) => {
  return (
    <SvgItem color={color} size={`${size}`}>
      <svg
        data-testid={'SvgIcon'}
        data-icon={name}
        xmlns="http://www.w3.org/2000/svg"
        id={id}
        width={`${size}`}
        height={`${size}`}
        data-test={id}
        color={color}
        viewBox={'0 0 24 24'}
        {...props}
      >
        {iconsSvgPath[name]}
      </svg>
    </SvgItem>
  );
};
